import actions from './moduleAuthActions'
import getters from './moduleAuthGetters'
import mutations from './moduleAuthMutations'
import state from './moduleAuthState'

export default {
    namespaced: true,
    actions: actions,
    getters: getters,
    mutations: mutations,
    state: state
}